import { render, staticRenderFns } from "./PsnTaxBfGrid.vue?vue&type=template&id=057627b4"
import script from "./PsnTaxBfGrid.vue?vue&type=script&lang=js"
export * from "./PsnTaxBfGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports